import {Spin} from 'antd'
import styled from 'styled-components'

export const StyledSpin = styled(Spin)`

  height: 100%;
  display:flex;
  justify-content:center;
  align-items:center;

  .ant-spin-dot-item {
    background-color: ${({ theme }) => theme.text.mainGreen};
  }

`
